// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageContainerStyles } from "@eisinc/Overrides/Widgets/Cart/CartPageContainer";
import { hideElementOnPrint } from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

cartPageContainerStyles.title = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        ${hideElementOnPrint}
    `,
};

cartPageContainerStyles.cartPageTemplate = {
    cartApproverMessage: {
        css: css`
            padding-bottom: 0;
            border-bottom: 0;
            ${TypographyStyle} {
                margin-bottom: 0;
            }
            ${hideElementOnPrint}
        `,
    },
    actionsSection: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
    totalSection: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
    headerSection: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
};

cartPageContainerStyles.wrapper = {
    css: css`
        @media print {
            &&& ~ * {
                display: none;
            }
        }
    `,
};
